<template>
    <div class="d-flex flex-column">
        <HelpPopup v-if="hasEstimatedPaymentAmount" icon="fa fa-info-circle" :muted="false" :icon-muted="true"
            placement="right">
            <template #label>
                <span class="mr-1 pay-amount">
                    {{ pricingCoverage.estimatedPatientPayAmount | currency }}
                </span>
            </template>
            <b-table-simple small class="mb-0">
                <tbody>
                    <tr>
                        <td><strong>Estimated Patient Cost</strong></td>
                        <td class="amount"><strong>{{ pricingCoverage.estimatedPatientPayAmount | currency }}</strong></td>
                    </tr>
                    <tr>
                        <td>Plan Pay Amount</td>
                        <td class="amount">{{ pricingCoverage.planPayAmount | currency }}</td>
                    </tr>
                    <tr>
                        <td>OOP Applied</td>
                        <td class="amount">{{ pricingCoverage.oopAppliedAmount | currency }}</td>
                    </tr>
                    <tr>
                        <td>OOP Remaining</td>
                        <td class="amount">{{ pricingCoverage.oopRemainingAmount | currency }}</td>
                    </tr>
                    <tr>
                        <td>Deductible Applied</td>
                        <td class="amount">{{ pricingCoverage.deductibleAppliedAmount | currency }}</td>
                    </tr>
                    <tr>
                        <td>Deductible Remaining</td>
                        <td class="amount">{{ pricingCoverage.deductibleRemainingAmount | currency }}</td>
                    </tr>
                </tbody>
            </b-table-simple>
        </HelpPopup>
        <div v-if="drugStatus.drugStatusCode">
            <b-badge :variant="drugStatus.drugStatusCode == 1 ? 'warning' : 'danger'" class="m-0">
                {{ drugStatusLabel }}
            </b-badge>
            <div v-if="drugStatus.freeText">
                <small>
                    {{ drugStatus.freeText }}
                </small>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import HelpPopup from '@/components/HelpPopup.vue';

@Component({
    name: "RTPBPatientCost",
    components: {
        HelpPopup
    }
})
export default class RTPBPatientCost extends Vue {
    @Prop({ required: true }) protected pricingCoverage!: any;

    get hasEstimatedPaymentAmount() {
        const payAmt = this.pricingCoverage.estimatedPatientPayAmount;
        return payAmt !== null && payAmt !== undefined;
    }

    get drugStatus() {
        return this.pricingCoverage.drugStatus;
    }

    get drugStatusLabel() {
        const labels: Record<number, string> = {
            0: "Covered",
            1: "Covered with Restrictions",
            2: "Error Processing Pharmacy Type",
            3: "Not Covered",
            4: "Pharmacy Type Not Supported",
            5: "Pharmacy Not Found"
        };

        return labels[this.drugStatus.drugStatusCode];
    }
}

</script>

<style scoped>
span.pay-amount,
td.amount {
    font-variant-numeric: tabular-nums;
}

span.pay-amount {
    font-size: 1.1em;
}

td.amount {
    text-align: right;
}

div.d-flex {
    gap: 5px;
}

small {
    font-weight: 500 !important;
}
</style>